import TrialsServiceClient from "@seneca/trials-service-client";

import { Dispatch, GetState } from "common/types";

import errorHandler from "services/trialsService/errorHandler";

import { isSignedIn } from "seneca-common/features/user/state";
import { awaitCondition } from "seneca-common/utils/state/await-condition";

import {
  fetchTrialsActionFactory,
  receivePremiumTrials,
  trialsFetchFinished,
  trialsNeedFetching
} from "../state";

export const makeFetchMyPremiumTrials = (
  getClient: () => TrialsServiceClient
) => {
  return fetchTrialsActionFactory({
    requestFunction: () => getClient().fetchPremiumTrials(),
    storeAction: receivePremiumTrials,
    errorHandler
  });
};

export const makeFetchMyPremiumTrialsIfNotFetched = (
  getClient: () => TrialsServiceClient
) => {
  const fetchMyTrials = makeFetchMyPremiumTrials(getClient);

  return function fetchMyTrialsIfNotFetched() {
    return async function (dispatch: Dispatch, getState: GetState) {
      const state = getState();

      if (isSignedIn(state)) {
        if (trialsNeedFetching(state)) {
          return dispatch(fetchMyTrials());
        } else {
          return dispatch(awaitCondition(trialsFetchFinished));
        }
      }
    };
  };
};
